<h2 class="text-2xl tracking-tighter font-poppins font-bold">Terms &amp; Conditions</h2>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">Company Address:</span></strong
  ><span data-preserver-spaces="true">
    Nuhome Living Ltd, Dobbies Lane, Marks Tey, Essex, CO6 1EP</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">Company Registration No:</span></strong
  ><span data-preserver-spaces="true"> 17340311</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">VAT No:</span></strong
  ><span data-preserver-spaces="true"> GB 525 9726 61</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">1. USE OF NUSTONE.CO.UK</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The nustone.co.uk site is provided to you free of charge for your personal
    use subject to these terms and conditions. By using the nustone.co.uk site
    you are agreeing to these terms and conditions. </span
  ><span data-preserver-spaces="true"
    >These do not affect your statutory rights.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">2. AMENDMENTS</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >We may update these terms and conditions from time to time and any changes
    will be notified to you via the email address provided by you on account
    registration or via a suitable announcement on the nustone.co.uk site. The
    changes will apply to the use of the nustone.co.uk site after we have given
    notice. If you do not wish to accept the new terms and conditions you should
    not continue to use the nustone.co.uk site. If you continue to use the
    nustone.co.uk site after the date on which the change comes into effect,
    your use of the nustone.co.uk site indicates your agreement to be bound by
    the new Terms and Conditions.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">3. PRIVACY</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Please review our
    <strong
      ><a href="/privacy-policy/" aria-label="Goes to privacy policy page" title="Privacy Policy"
        >Privacy Policy</a
      ></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >4. THE CONTRACT BETWEEN US</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >We must receive full payment for the price of the goods that you order
    before your order can be processed. Once payment has been received by us, we
    will confirm that the goods ordered are available and in stock, by sending
    an email to you at the email address you provided on the checkout page. We
    will then despatch the goods to the address provided on the checkout page.
    In the unlikely event that the goods ordered are not available, we shall
    email you at the email address you provided on the checkout page and arrange
    for your payment to be refunded </span
  ><span data-preserver-spaces="true">or a suitable alternative.</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">5. PRICE &amp; DISCOUNTS</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.1. The price payable for goods that you order is set out on our website
    at the time of purchase.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.2 You may be required to pay extra for delivery and it might not be
    possible for us to deliver to some locations. Our delivery charges and
    restricted delivery areas are fully detailed on our
    <strong><a aria-label="Goes to delivery page" title="Delivery" href="/delivery/">Delivery Page</a></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  5.3 Quotes are given based on the current price of the goods. Prices are
  subject to fluctuation and cannot be guaranteed.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  5.4 Discount codes and trade discounts are not valid with any other offer or
  discount and exclude Sample, Sale and Joint It products.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  5.5 Prices and discount percentages may be rounded to the closest full number.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.6 All discount codes apply to the value of the applicable items,
    excluding delivery charges, and are subject to our general Terms and
    Conditions.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.7 The discount code must be entered in the ‘discount code’ field on the
    basket or checkout page </span
  ><span data-preserver-spaces="true">for the discount to </span
  ><span data-preserver-spaces="true">be deducted</span
  ><span data-preserver-spaces="true"> from the order.</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.8 The discount code can only be redeemed</span
  ><span data-preserver-spaces="true"> at www.nustone.co.uk.</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.9 The order value must meet any minimum required amount of qualifying
    products as specified on </span
  ><span data-preserver-spaces="true">the means by which</span>
  <span data-preserver-spaces="true">the discount code was communicated</span
  ><span data-preserver-spaces="true">.</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.10 Discount codes are limited to one use per customer.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >5.11 Nustone reserves the right to amend or withdraw the discount codes at
    any given time without prior notic</span
  ><span data-preserver-spaces="true">e.</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true">25.12 No discounts will be gi</span
  ><span data-preserver-spaces="true">ven retrospectively.</span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >6. VARIATIONS &amp; INSTALLATION</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >We endeavour to display as accurately as possible the colours and sizes of
    our products on our website, however, each batch is unique. We </span
  ><span data-preserver-spaces="true"
    >strongly advise reading through all product descriptions thoroughly and to
    avoid basing purchasing decisions on images alone. </span
  ><span data-preserver-spaces="true"
    >For further information on variations in natural stone, please see the
    information on our website
    <strong><a aria-label="Goes to installation guide page" href="/installation-guide/">here</a></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  The variations that you will see in each crate may differ from the images
  displayed on our website and we<span data-preserver-spaces="true">
    do our best to display images of each product as accurately as we can.
    Please keep in mind that these are customer-submitted images of natural
    products in natural lighting and cannot account for differences in natural
    lighting, moisture within the slabs or any products used during or after
    installation.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >A natural product will often have a fine layer of dust from the quarrying
    process and this can sometimes cause the slabs to look a little lighter in
    colour at first. Colours will intensify and darken when the slab is wet and
    once laid, the stone will naturally take in moisture from the mortar bed
    which will help to bring out more of the natural colours. To test this, you
    can pour a little water onto the slabs whilst they are still in the crate
    which will bring out some more of the natural colours.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >An allowance should be made for +/- 5mm to cover natural variations in the
    dimensions specified for sandstone, slate and limestone paving, +/- 2mm for
    granite paving and +/- 10mm for cobbles &amp; setts.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Man-made stones are also produced in batches and can vary in colour and print
  from batch to batch. We advise keeping this in mind when placing a
  made-to-measure or top-up order.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    >The responsibility for the correct installation of the product lies with
    the customer. Products do not come with a guarantee or warranty pre or
    post-installation.</strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >We always recommend seeking advice from an industry professional who can
    assess the specific needs of each project before work begins. Nustone.co.uk
    or Nuhome Living Ltd does not take any part in the installation of the
    product and cannot be held responsible for the incorrect installation of
    materials supplied or any faults found in products after installation.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  You may see changes in the stone after the installation of the product.
  Anything which appears on the slabs post-installation can only have occurred
  due to the installation process as this is the only variable between the
  receipt of the goods and the effects arising. Nuhome Living Ltd cannot be
  held responsible for anything which occurs to the slabs after use.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >7. RIGHT FOR YOU TO CANCEL YOUR CONTRACT</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >7.1. Please read our
    <strong
      ><a aria-label="Opens return policy page" title="Returns Policy" href="/returns-policy/"
        >Cancellation &amp; Returns Policy</a
      ></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">8. CANCELLATION BY US</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >8.1. We reserve the right to cancel the contract between us if:</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >8.1.1. we have insufficient stock to deliver the goods you have
    ordered;</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >8.1.2. we do not deliver to your area; or</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >8.1.3. one or more of the goods you ordered was listed at an incorrect
    price due to a typographical error or an error in the pricing information
    received by us from our suppliers.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >8.2. If we do cancel your contract we will notify you by email and will
    re-credit to your account any sum deducted by us from your credit card as
    soon as possible but in any event within 30 days of your order. We will not
    be obliged to offer any additional compensation for any disappointment
    suffered.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >9. DELIVERY OF GOODS TO YOU</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Please read our full
  <strong
    ><a title="Delivery" aria-label="Goes to delivery page" href="/delivery/">Delivery Information</a></strong
  >.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4"><strong>Delivery Process</strong></p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Our standard delivery method is a one-man, kerbside delivery using a tail-lift
  and manual pallet truck to deliver onto a hard, level surface on the kerb or
  at the roadside. <!-- <strong>Please Note:</strong> HIAB or grab lorries are not
  part of our standard delivery method. -->
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Each crate weighs up to one tonne and will be moved manually with a pallet
  truck. Pallet trucks will not move on grass, gravel or inclines. Delivery will
  need to be made to a hard, flat and level surface on the kerb or at the
  roadside.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Delivery will require clear access with space to manoeuvre and turn for an
  18-tonne vehicle. Please inform Nustone or our couriers of any access
  restrictions at the delivery point to ensure that delivery does not fail. If
  delivery fails, re-delivery or return/cancellation fees will apply.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong>Please Note: </strong>Vehicles require obstacle-free access to the
  kerbside to be able to make the delivery. Delivery vehicles require a
  different level of access to bin lorries, and clear access must be left along
  the road whilst making the delivery.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Failure to inform us about potential access issues may incur additional
  delivery costs.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">Estimated lead times begin from the date that the order was paid.</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  If Nustone is not notified of any potential access issues when placing the
  order, the estimated delivery timeframe can no longer apply due to the
  challenges of delivering the goods.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4"><strong>Accepting Your Delivery</strong></p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Please check over your goods at the time of delivery before signing the
  delivery note/POD. If you discover anything wrong, please sign for the
  delivery as ‘Damaged’. If you cannot check or sign for your goods, we advise
  that you have somebody do this on your behalf. If you need the goods left
  unsigned, please let us know in the customer-provided notes at checkout.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Customers must check the goods for any visible damages with the driver
  present. If you find any visible damage to the crate, such as splintered wood
  or even if the crate is leaning slightly to one side, please sign the delivery
  note/POD as ‘Damaged’.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  If there are no visible damages, we urge you to open the top of the crate to
  check for any concealed damage to the goods. If any concealed damages are
  discovered, please sign the delivery note/POD as ‘Damaged’.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  To do this, simply write the word ‘Damaged’ next to your signature, whether on
  paper or on a handheld device. The driver may not have the delivery note/POD
  on them whilst manoeuvring the goods, so be sure to request this before they
  leave so that you can sign for the goods. We advise signing the delivery
  note/POD yourself and if the driver is signing on your behalf, always be sure
  to check that the goods are signed for as you see fit. Please note that
  signing as ‘Unchecked’ will not cover you for any damages discovered.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Unless otherwise stated, a signature confirms that the goods have been
  delivered in satisfactory condition and are free from any visible signs of
  damage.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Customers are not expected to check every slab upon arrival and only need to
  find a single case of damage in order to sign as ‘Damaged’. Once this is done,
  you have a full 3 days in which to check the full order and raise a claim
  <strong><a title="Waste and Damage" aria-label="Opens waste and damage page" href="/waste-and-damages/">here</a></strong
  >.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Each driver has a maximum of 20 minutes per delivery for you to do this and
  you can request that they wait for the full duration when necessary.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  It is the customer’s responsibility to ensure that the goods are signed for.
  Please be sure that the person receiving the delivery is familiarised with our
  full procedure and always ensure that you have signed the delivery note before
  the driver leaves. If you have any issues at the time of delivery, please
  contact us ASAP so that we can advise you accordingly.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  We always advise accepting the delivery to avoid incurring any re-delivery or
  return charges.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">10. </span></strong
  ><strong><span data-preserver-spaces="true">DAMAGES</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Whilst every effort is taken to ensure that each crate is packed safely and
    securely, damages can occur in transit, so please be sure that you have the
    full amount of useable goods on-site before booking in any tradespersons or
    starting your project. This will allow you time to check for damage and
    raise a claim before your project starts and will avoid any damages holding
    up work.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  We will issue a refund to the total value of the goods damaged for a
  successful claim.
  <strong>Please note that we do not offer free replacements.</strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Any slabs which are damaged can typically be used for offcuts and we
    recommend using any such slabs in a way where any damaged portion is
    discarded. This allows you to use the maximum amount of stone possible
    without laying anything that could be unsuitable.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Chips to the edges or corners of a slab can occur when unpacking crates or
    during transportation. These will not affect the performance of the slab and
    are typically concealed once the patio has been pointed.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >We are unable to accept claims for orders that the customer has collected
    or arranged to have collected by a third party.
  </span>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">Claims cannot be accepted for any product which has been used.</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >If you do have any damages which have been noted at the time of accepting
    your delivery, please follow our claims procedure
    <strong><a title="Waste and damage" aria-label="Goes to waste and damage page" href="/waste-and-damages/">here</a></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  One claim can be submitted per order, so please ensure that each instance of
  damage is reported within a single claim.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.1. If the goods we deliver are not what you ordered, are damaged,
    defective or the delivery is of an incorrect quantity, we shall have no
    liability to you unless you notify us in writing at
    <a
      href="/cdn-cgi/l/email-protection"
      class="__cf_email__"
      data-cfemail="63101613130c1117230d1610170c0d064d000c4d1608"
      >[email&#160;protected]</a
    >
    highlighting the issue within 3 days of the final delivery of the goods in
    question. The burden of proof is on the customer to prove the item is not of
    satisfactory quality and a second opinion from an independent party may be
    necessary to provide this evidence. Should this be due to any fair, wear and
    tear, misuse or accidental damage, Nuhome Living Ltd cannot be held
    liable.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.2. Due to the long distances that our products travel, some damage can
    occur. If the product you purchase is damaged or faulty, we may offer an
    exchange or refund as appropriate in accordance with sections 10.4.1.,
    10.4.2. and 10.4.3. If the goods have arrived damaged, we ask you to sign
    for them as “damaged” on arrival. It is important for you to inspect the
    delivery before signing. If the delivery note is not claused, we are unable
    to process any claim for damages. Once delivery has taken place, we
    recommend that you open a claim. You can see how to do this
    <strong><a href="/waste-and-damages/">here</a></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.3. Nustone.co.uk will not refund or replace tiles or slabs that fall
    under the minimum of 5% of acceptable loss. This should be taken into
    account when placing your order as we advise that 10-15% should be added to
    your order to allow for wastage and cuts.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.4. If you do not receive goods ordered by you within 30 days of the date
    on which you ordered them, we shall have no liability to you unless you
    notify us in writing at our contact address of the problem within 40 days of
    the date on which you ordered the goods.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >If you notify a problem to us under this condition, our only obligation
    will be, at our option:</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.4.1. to make good any shortage or non-delivery;</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.4.2. to replace or repair any goods that are damaged or defective;
    or</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.4.3. to refund you the amount paid by you for the goods in question in
    whatever way we choose.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.5. Save as precluded by law, we will not be liable to you for any
    indirect or consequential loss, damage or expenses (including loss of
    profits, business or goodwill) howsoever arising out of any problem you
    notify to us under this condition and we shall have no liability to pay any
    money.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >10.6. Notwithstanding the foregoing, nothing in these terms and conditions
    is intended to limit any rights you might have as a consumer under
    applicable UK law or other statutory rights that may not be excluded nor in
    any way to exclude or limit our liability to you for any death or personal
    injury resulting from our negligence.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">10.7 Nuhome Living Ltd cannot be held liable for any loss</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">11. AREA CALCULATION</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The m² coverage listed for each product page reflects the total area that
    you can expect to cover using the stone, including the recommended joint
    widths for spaces between the slabs. This is to help give a realistic figure
    of the area that the product will cover once laid and will help customers to
    place their order accurately.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The total area coverage of the stone alone can be calculated using slab
    measurements and quantities. Whilst every attempt has been made to provide
    you with the ability to accurately calculate the coverage ordered, we
    recommend that customers double-check all area calculations prior to
    completing the order. Nuhome Living Ltd cannot be held responsible for
    under or over-ordering.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">12. NOTICES</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Unless otherwise expressly stated in these terms and conditions, all
    notices from you to us must be in writing and sent to our contact address at
    <a
      href="/cdn-cgi/l/email-protection"
      class="__cf_email__"
      data-cfemail="4734323737283533072932343328292269242869322c"
      >[email&#160;protected]</a
    >
    and all notices from us to you will be displayed on our website from to
    time.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >13. EVENTS BEYOND OUR CONTROL</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >We shall have no liability to you for any failure to deliver goods you have
    ordered or any delay in doing so or for any damage or defect to goods
    delivered that is caused by any event or circumstance beyond our reasonable
    control including without limitation, vehicle delays, strikes, lockouts and
    other industrial disputes, breakdown of systems or network access, flood,
    fire, explosion or accident.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">14. LIMITATIONS</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >You may not use the nustone.co.uk site for any of the following
    purposes:</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >DISSEMINATING ANY UNLAWFUL, HARASSING, LIBELLOUS, ABUSIVE, THREATENING,
    HARMFUL, VULGAR, OBSCENE, OR OTHERWISE OBJECTIONABLE MATERIAL</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >TRANSMITTING MATERIAL THAT ENCOURAGES CONDUCT THAT CONSTITUTES A CRIMINAL
    OFFENCE RESULTS IN CIVIL LIABILITY OR OTHERWISE BREACHES ANY RELEVANT LAWS,
    REGULATIONS OR CODE OF PRACTICE</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >GAINING UNAUTHORISED ACCESS TO OTHER COMPUTER SYSTEMS</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >INTERFERING WITH ANY OTHER PERSON’S USE OR ENJOYMENT OF THE NUSTONE.CO.UK
    SITE</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >BREACHING ANY LAWS CONCERNING THE USE OF PUBLIC TELECOMMUNICATIONS
    NETWORKS</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >INTERFERING OR DISRUPTING NETWORKS OR WEBSITES CONNECTED TO THE
    NUSTONE.CO.UK SITE</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >MAKING, TRANSMITTING OR STORING ELECTRONIC COPIES OF MATERIALS PROTECTED BY
    COPYRIGHT WITHOUT THE PERMISSION OF THE OWNER</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >You will indemnify us against all losses, liabilities, costs and expenses
    reasonably suffered or incurred by us, all damages awarded against us under
    any judgment by a court of competent jurisdiction and all settlements sums
    paid by us as a result of any settlement agreed by us arising out or in
    connection with:</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >ANY CLAIM BY ANY THIRD PARTY THAT THE USE OF THE NUSTONE.CO.UK SITE BY YOU
    IS DEFAMATORY, OFFENSIVE OR ABUSIVE, OR OF AN OBSCENE OR PORNOGRAPHIC
    NATURE, OR IS ILLEGAL OR CONSTITUTES A BREACH OF ANY APPLICABLE LAW,
    REGULATION OR CODE OF PRACTICE;</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >ANY CLAIM BY ANY THIRD PARTY THAT THE USE OF THE NUSTONE.CO.UK SITE BY YOU
    INFRINGES THAT THIRD PARTY’S COPYRIGHT OR OTHER INTELLECTUAL PROPERTY RIGHTS
    OF WHATEVER NATURE; AND</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >ANY FINES OR PENALTIES IMPOSED BY ANY REGULATORY, ADVERTISING OR TRADING
    BODY OR AUTHORITY IN CONNECTION WITH THE USE OF THE NUSTONE.CO.UK SITE BY
    YOU.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >15. AVAILABILITY OF THE NUSTONE.CO.UK SITE</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Although nustone.co.uk aims to offer you the best service possible,
    nustone.co.uk makes no promise that the services at the nustone.co.uk site
    will meet your requirements. Nustone.co.uk cannot guarantee that the service
    will be fault-free. If a fault occurs in the service you should report it to
    email at
    <a
      href="/cdn-cgi/l/email-protection"
      class="__cf_email__"
      data-cfemail="2c5f595c5c435e586c42595f58434249024f43025947"
      >[email&#160;protected]</a
    >
    and we will attempt to correct the fault as soon as we reasonably can.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Your access to the nustone.co.uk site may be occasionally restricted to
    allow for repairs, maintenance or the introduction of new facilities or
    services. Nustone.co.uk will attempt to restore the service as soon as it
    reasonably can.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >16. NUSTONE.CO.UK’S RIGHT TO SUSPEND OR CANCEL YOUR REGISTRATION</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Nustone.co.uk may suspend or cancel your registration immediately at our
    reasonable discretion or if you breach any of your obligations under these
    Terms and Conditions.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >You can cancel this agreement at any time by informing us in writing. If
    you do so, you must stop using the nustone.co.uk site.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The suspension or cancellation of your registration and your right to use
    the nustone.co.uk site shall not affect either party’s rights or
    liabilities.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Paragraphs 11 and 15 of these Terms and Conditions shall survive
    cancellation.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true"
      >17. NUSTONE.CO.UK’S LIABILITY</span
    ></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The nustone.co.uk site is provided by nustone.co.uk without any warranties
    or guarantees. You must bear the risks associated with the use of the
    Internet. The nustone.co.uk site provides content from other Internet sites
    or resources and while nustone.co.uk tries to ensure that material included
    on the nustone.co.uk site is correct, reputable and of high quality, it
    cannot accept responsibility if this is not the case. Nustone.co.uk will not
    be responsible for any errors or omissions or for the results obtained from
    the use of such information or for any technical problems you may experience
    with the nustone.co.uk site. If nustone.co.uk is informed of any
    inaccuracies in the material on the site we will attempt to correct the
    inaccuracies as soon as we reasonably can.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >In particular, we disclaim all liabilities in connection with the
    following:</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >INCOMPATIBILITY OF THE NUSTONE.CO.UK SITE WITH ANY OF YOUR EQUIPMENT,
    SOFTWARE OR TELECOMMUNICATIONS LINKS</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >TECHNICAL PROBLEMS INCLUDING ERRORS OR INTERRUPTIONS OF THE NUSTONE.CO.UK
    SITE</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >UNSUITABILITY, UNRELIABILITY OR INACCURACY OF THE NUSTONE.CO.UK SITE</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >INADEQUACY OF THE NUSTONE.CO.UK SITE (TO MEET YOUR REQUIREMENTS)</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >To the full extent allowed by applicable law, you agree that we will not be
    liable to you/or any third party for any consequential or incidental damages
    (including but not limited to loss of revenue, loss of profits, loss of
    anticipated savings, wasted expenditure, loss of privacy and loss of data)
    or any other indirect, special or punitive damages whatsoever that arise out
    of or are related to the nustone.co.uk site.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Nothing in these Terms and Conditions shall exclude nustone.co.uk’s
    liability for personal injury or death caused by its negligence.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">18. INVALIDITY</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >If any part of these terms and conditions is unenforceable (including any
    provision in which we exclude our liability to you) the enforceability of
    any other part of these conditions will not be affected.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">19. PRIVACY</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >You acknowledge and agree to be bound by the terms of our
    <strong
      ><a href="/privacy-policy/"
        >Privacy Policy</a
      ></strong
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">20. THIRD-PARTY RIGHTS</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >Except for our affiliates, directors, employees or representatives, a
    person who is not a party to this agreement has no right under the UK
    Contracts (Rights of Third Parties) Act 1999 to enforce any term of this
    agreement but this does not affect any right or remedy of a third party that
    exists or is available apart from that Act.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">21. INTELLECTUAL PROPERTY</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The content of the nustone.co.uk Site is protected by copyright,
    trademarks, database and other intellectual property rights. You may
    retrieve and display the content of the nustone.co.uk site on a computer
    screen, or print one copy of such content for your own personal,
    noncommercial use, provided you keep intact all and any copyright and
    proprietary notices.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >You may not otherwise reproduce, modify, copy or distribute or use for
    commercial purposes any of the materials or content on the nustone.co.uk
    site without written permission from nustone.co.uk. No licence is granted to
    you in these Terms and Conditions to use any trademark of nustone.co.uk or
    its affiliated companies including, without limitation, the trademarks
    Nuhome Living Ltd and nustone.co.uk.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">22. GOVERNING LAW</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The contract between us shall be governed by and interpreted in accordance
    with English law and the English courts shall have jurisdiction to resolve
    any disputes between us.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">23. ENTIRE AGREEMENT</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >These terms and conditions, together with our current website prices,
    delivery details, contact details and privacy policy, set out the whole of
    our agreement relating to the supply of the goods to you by us. Nothing said
    by any salesperson on our behalf should be understood as a variation of
    these terms and conditions or as an authorised representation about the
    nature or quality of any goods offered for sale by us. Save for fraud or
    fraudulent misrepresentation, we shall have no liability for any such
    representation being untrue or misleading.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">24. MISCELLANEOUS</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >You may not assign, sublicense or otherwise transfer any of your rights
    under these Terms and Conditions. If any provision of these Terms and
    Conditions is found to be invalid by any court having competent
    jurisdiction, the invalidity of that provision will not affect the validity
    of the remaining provisions of these Terms and Conditions, which shall
    remain in full force and effect</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >If you breach these Terms and Conditions and nustone.co.uk ignores this,
    nustone.co.uk will still be entitled to use its rights and remedies at a
    later date or in any other situation where you breach the Terms and
    Conditions. Nustone.co.uk shall not be responsible for any breach of these
    Terms and Conditions caused by circumstances beyond its control. A person
    who is not a party to these Terms and Conditions shall have no right under
    the Contract (Rights of Third Parties) Act 1999 to enforce any term of these
    Terms and Conditions but this shall not affect any right or remedy of a
    third party which exists or is available apart from that Act. The
    nustone.co.uk site is owned and operated by Nuhome Living Ltd who can be
    contacted at Nuhome Living Ltd, Dobbies Lane, Marks Tey, Essex, CO6
    1EP.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >If you have any queries please contact
    <a
      href="/cdn-cgi/l/email-protection"
      class="__cf_email__"
      data-cfemail="7605030606190402361803050219181358151958031d"
      >[email&#160;protected]</a
    >.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong
    ><span data-preserver-spaces="true">25. PROPRIETARY RIGHTS</span></strong
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >All Intellectual Property Rights of the materials on this website, together
    with the underlying software code are owned by Nuhome Living Ltd. All
    text, artwork, graphics and images on the website are owned by Nuhome
    Living Ltd and subject to copyright and intellectual property rights
    unless otherwise specified. Without prior written permission, you may not
    use, copy, modify, alter, publish, broadcast, distribute, sell or transfer
    any material on this website or the underlying software code whether in
    whole or in part.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <strong><span data-preserver-spaces="true">26. MAILING</span></strong>
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  <span data-preserver-spaces="true"
    >The email address provided upon placing your order may be used to keep you
    informed of special offers, promotions and news relating to Nuhome Living Ltd and our products. Your details will never be shared with any third-party
    companies.</span
  >
</p>
<p class="text-base font-roboto-slabs font-normal mb-4"><strong>27. LIABILITY</strong></p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Nuhome Living Ltd cannot be held responsible and offer no compensation for
  any loss incurred by the customer due to a delay in delivery, damages in
  transit or incorrect products received due to third-party couriers. This
  includes but is not limited to the booking of tradespeople and tool or
  equipment hire.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Nuhome Living Ltd cannot be held responsible and offers no compensation for
  any damage or injury caused when using our products and recommends that risk
  assessments and health and safety guidelines are undertaken, followed and
  enforced at all times when using our products.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4"><strong>28. FIND A LANDSCAPER &amp; BUSINESS LISTINGS</strong></p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  You must have the permission of the business owner to apply for
  Nustone&#8217;s &#8216;Find A Landscaper&#8217; feature.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">The details provided must be correct to the best of your knowledge.</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Your Nustone &#8216;Find A Landscaper&#8217; listing and its content remains
  the property of Nustone and may be used for marketing purposes, including but
  not limited to, displaying the listing on our website, social media and
  advertisements.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Nustone must be made aware of any changes to the details you have given in
  order to maintain and update your profile.
</p>
<p class="text-base font-roboto-slabs font-normal mb-4">
  Nustone reserve the right to refuse, remove or exclude any listing or
  application.
</p>
